import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Formik } from "formik";
import { GetMedia, Alerts } from "../../helpers";
import { FaCheck } from "react-icons/fa";
import MultipleFileDropzone from './MultipleFileDropzone';

const MediaLibraryPopup = ({ show, setShowMedia, isMulti = true, handleSelectImage, setFieldValue, fieldName, handleImageSubmit }) => {
  const [isLoading, setLoading] = useState(false);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentSelected, setCurrentSelected] = useState([]);

  const getData = async (crt_page, isAdded = false) => {
    setLoading(true);
    try {

      const resp = await GetMedia.getAllMedia(crt_page);
      if (resp && resp.status) {
        setMediaFiles(prevData => {
          if (crt_page === 1) {
            return resp.data;
          } else {
            return [...prevData, ...resp.data];
          }
        });
        setCurrentPage(resp.currentPage);
        setTotalPages(resp.totalPages);
      }
    } catch (error) {
      console.error("Error fetching media:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData(currentPage);
    setCurrentSelected([]); // reset on open
  }, [show, currentPage]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setLoading(true);
    try {
      const formData = new FormData();
      values.media_file.forEach((file) => {
        formData.append("media_file", file);
      });

      const resp = await GetMedia.createMedia(formData);
      if (resp && resp.status) {
        getData(1, true);
        Alerts.alertMessage(resp.message, "top-right", "success");
      } else {
        Alerts.alertMessage(resp.message, "top-right", "error");
      }
    } catch (error) {
      console.error("Error uploading media:", error);
    } finally {
      resetForm();
      setSubmitting(false);
    }
  };

  const handleLoadMore = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handleSelectImageFromMedia = (image) => {
    if (isMulti) {
      setCurrentSelected((prevSelected) => {
        const alreadySelected = prevSelected.some((item) => item.id === image.id);
        if (alreadySelected) {
          return prevSelected.filter((item) => item.id !== image.id);
        } else {
          return [...prevSelected, image];
        }
      });
    } else {
      setCurrentSelected([image]);
    }
  };

  const handleSubmitImages = () => {
    const value = isMulti ? currentSelected : currentSelected[0] || null;
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, value);
    }


    if (handleImageSubmit) {
    
      handleImageSubmit(value);
    }
    setShowMedia(false);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShowMedia(false)}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Media Library</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pd-50' scrollable={true}>
          {isLoading ? (
            <div className='loader'>
              <img src='/images/loader.gif' alt='loader' />
            </div>
          ) : (
            <Tabs
              defaultActiveKey="media"
              transition={false}
              id="noanim-tab-example"
              className="mb-3 media-gallery-popup"
            >
              <Tab eventKey="media" title="Choose From Media">
                <div className='media-library row scrollBox'>
                  {mediaFiles.length > 0 && mediaFiles.map((item) => (
                    (item.file_type === 'image' || item.file_type === 'video') && (
                      <div className='col-md-3 mb-20' key={item.id}>
                        <div className={`media-item ${currentSelected.some((img) => img.id === item.id) ? 'active' : ''}`} onClick={() => handleSelectImageFromMedia(item)}>
                          <div className='thumbnail'>
                            <div className='centered'>
                              {currentSelected.some((img) => img.id === item.id) && (
                                <div className='checkedWrap'>
                                  <FaCheck />
                                </div>
                              )}
                              {item.file_type === 'image' ? (
                                <img src={item.path} alt={item.filename} />
                              ) : (
                                <img src={'/images/video.svg'} alt={item.filename} className='icon' />
                              )}
                            </div>
                            {item.file_type === 'video' && (
                              <div className='filename'>{item.filename}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )
                  ))}
                </div>
                <div className='popup-action'>
                  {totalPages > currentPage && (
                    <div className='text-center mt-20'>
                      <button onClick={handleLoadMore} className='load_more'>Load More</button>
                    </div>
                  )}
                  {currentSelected.length > 0 && (
                    <div className='text-center mt-20'>
                      <button type='button' className='load_more' onClick={handleSubmitImages}>
                        Insert {isMulti ? `${currentSelected.length} Files` : "Image"}
                      </button>
                    </div>
                  )}
                </div>
              </Tab>
              <Tab eventKey="browse" title="Browse">
                <Formik
                  initialValues={{ media_file: [] }}
                  validate={(values) => {
                    const errors = {};
                    if (values.media_file.length === 0) {
                      errors.media_file = "At least one file is required.";
                    } else if (values.media_file.length > 10) {
                      errors.media_file = "You can upload a maximum of 10 files.";
                    }
                    return errors;
                  }}
                  onSubmit={handleSubmit}
                >
                  {({ values, errors, touched, handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <MultipleFileDropzone setFieldValue={setFieldValue} fieldName="media_file" prevImageHeight={100} prevImageWidth={100} />
                        {errors.media_file && touched.media_file && (
                          <div className="text-center">
                            <span className="help-error">{errors.media_file}</span>
                          </div>
                        )}
                      </div>

                      <div className="text-center">
                        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                          {isSubmitting ? "Uploading..." : "Upload File"}
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </Tab>
            </Tabs>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MediaLibraryPopup;

